import { useEffect, useState } from "react";
import { backend, billurl, producturl } from "../../../../path";
import useRazorpay from "react-razorpay";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import ScrollToTop from "../../../components/whatsapp connect";
import LoaderMain from "../../../layout/header/loader_sub";
import { Link, useNavigate } from "react-router-dom";
import styled, { keyframes } from "styled-components";
import { Button, Collapse, Modal } from "react-bootstrap";
import { HiOutlinePlus } from "react-icons/hi2";

function MyOrdersUser() {
  const [loading, setLoading] = useState();
  const [error, setError] = useState();
  const [data, setData] = useState([]);
  const [Razorpay] = useRazorpay();
  const [formData, setFormData] = useState({});
  const [newAdd, setNewAdd] = useState({
    country: "102",
  });
  const [count, setCountry] = useState([]);
  const [address, setAddress] = useState([]);
  const [delAd, setDelAd] = useState(null);
  const [isAddressModalOpen, setIsAddressModalOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const [delivery, setDelivery] = useState(false);
  const [newDelivery, setNewDelivery] = useState(false);
  const [copy, setCopy] = useState(false);
  const navigate = useNavigate();
  const [isHovered, setIsHovered] = useState(false);
  const RAZORPAY_KEY = process.env.REACT_APP_RAZORPAY_KEY;

  const [authenticated] = useState(
    JSON.parse(localStorage.getItem("userdata"))
  );
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const fetchData = () => {
    setLoading(true);

    fetch(backend + `getmyorders`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authenticated?.access_token}`,
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        setData(data);
      })
      .catch((error) => {
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const fetchCountryData = () => {
    // Assuming setData, setError, and setLoading are state functions from useState
    setLoading(true);

    fetch(backend + "getcountry", {
      method: "GET",
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        setCountry(data);
      })
      .catch((error) => {
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const fetchAddress = () => {
    setLoading(true);

    fetch(backend + "getaddress", {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authenticated?.access_token}`,
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        setAddress(data);
        if (Array.isArray(data) && data.length > 0) {
          const last = data[data.length - 1];
          setFormData(last);
          setDelAd(last?.delivery_address_id);
        } else {
          setFormData({ country: "102" });
          setDelAd(null);
        }
      })
      .catch((error) => {
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const calculateTotalMRP = () => {
    let total = 0;
    data.forEach((item) => {
      total += item?.total;
    });
    return total;
  };

  useEffect(() => {
    fetchData();
    fetchCountryData();
    fetchAddress();
  }, []);

  // const handleQuantityChange = async (id, qty) => {
  //   console.log("Handling quantity change for ID:", id);
  //   console.log("New quantity:", qty);

  // };

  const handleCancelClick = (orderId) => {
    const userConfirmed = window.confirm(
      "Are you sure you want to cancel this order ? 🙁"
    );
    if (userConfirmed) {
      handleCancelOrder(orderId);
    }
  };

  const handleCancelOrder = async (id) => {
    const formData = {
      order_id: id,
    };
    try {
      const response = await fetch(backend + `cancelorder`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${authenticated?.access_token}`,
        },
        body: JSON.stringify(formData),
      });

      if (response.status === 200) {
        fetchData();
        toast.success("Order Cancelled. Your refund will be processed to your original payment method within 5-7 business days.", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else if (response.status === 409) {
      } else {
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleDeleteAddress = async (id) => {
    if (!window.confirm("Are you sure you want to delete this address?")) {
      return;
    }
    try {
      const response = await fetch(backend + `deleteaddress/${id}`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${authenticated?.access_token}`,
        },
      });

      if (response.status === 200) {
        fetchAddress();
        toast.success("Address Deleted", {
          position: "top-right",
          autoClose: 3000,
        });
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  //payment

  const handlePayment = async (id, total, details) => {
    if (!RAZORPAY_KEY) {
      toast.error("Payment gateway unavailable. Please contact support.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return;
    }

    const options = {
      key: RAZORPAY_KEY,
      amount: total * 100,
      currency: "INR",
      name: "Kerala Specials",
      description: "Order Payment",
      image: "https://example.com/your_logo",
      handler: function (response) {
        // alert(response.razorpay_payment_id);
        handleSuccessOrder(id, response.razorpay_payment_id);
      },
      prefill: {
        name: `${details.first_name} ${details.last_name}`,
        email: `${details.email}`,
        contact: `${details.contact}`,
      },
      notes: {
        address: "Razorpay Corporate Office",
      },
      theme: {
        color: "#3399cc",
      },
    };

    const rzp1 = new Razorpay(options);

    rzp1.on("payment.failed", function (response) {
      alert(response.error.code);
      alert(response.error.description);
      alert(response.error.source);
      alert(response.error.step);
      alert(response.error.reason);
      alert(response.error.metadata.order_id);
      alert(response.error.metadata.payment_id);
    });

    rzp1.on("payment.success", function (response) { });
    setLoading(false);
    rzp1.open();
  };

  const handleSubmit = () => {
    // List of required fields and their corresponding display names
    const requiredFields = [
      { key: "first_name", displayName: "First Name" },
      { key: "house_name", displayName: "House Name" },
      { key: "street_name", displayName: "Street Name" },
      { key: "country", displayName: "Country" },
      { key: "state", displayName: "State" },
      { key: "city", displayName: "City" },
      { key: "pincode", displayName: "Pincode" },
      { key: "contact", displayName: "Contact" },
    ];

    // Check if any required field is missing or blank
    const invalidField = requiredFields.find((field) => {
      const value = formData[field.key];
      return typeof value !== "string" || value.trim() === ""; // Check if value is not a string or is empty or consists of only whitespace
    });

    if (invalidField) {
      toast.error(`${invalidField.displayName} cannot be blank`, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return; // Stop further execution
    }

    fetch(backend + "addaddress", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authenticated?.access_token}`,
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        if (!response.ok) {
          console.error(
            "Failed to register:",
            response.status,
            response.statusText
          );
          if (response.status === 409) {
            toast.error("Something Went Wrong", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else {
            toast.error("Something Went Wrong", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }

          return;
        }

        response.json().then(() => {
          handleOrder();
          // Additional success handling code here
          toast.success("Primary Address Updated", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        });
        // navigate("/admin-users");
      })
      .catch((error) => {
        toast.error("Something Went Wrong", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      });
  };
  const handleSubmitNewAddress = () => {
    // List of required fields and their corresponding display names
    const requiredFields = [
      { key: "first_name", displayName: "First Name" },
      { key: "house_name", displayName: "House Name" },
      { key: "street_name", displayName: "Street Name" },
      { key: "country", displayName: "Country" },
      { key: "state", displayName: "State" },
      { key: "city", displayName: "City" },
      { key: "pincode", displayName: "Pincode" },
      { key: "contact", displayName: "Contact" },
    ];

    // Check if any required field is missing or blank
    const invalidField = requiredFields.find((field) => {
      const value = newAdd[field.key];
      return typeof value !== "string" || value.trim() === ""; // Check if value is not a string or is empty or consists of only whitespace
    });

    if (invalidField) {
      toast.error(`${invalidField.displayName} cannot be blank`, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return; // Stop further execution
    }

    fetch(backend + "addaddress", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authenticated?.access_token}`,
      },
      body: JSON.stringify(newAdd),
    })
      .then((response) => {
        if (!response.ok) {
          console.error(
            "Failed to register:",
            response.status,
            response.statusText
          );
          if (response.status === 409) {
            toast.error("Something Went Wrong", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else {
            toast.error("Something Went Wrong", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }

          return;
        }

        response.json().then((data) => {
          handleOrderAddress(data?.delivery_address_id);
          // Additional success handling code here
          toast.success("Address Added", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        });
        // navigate("/admin-users");
      })
      .catch((error) => {
        toast.error("Something Went Wrong", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      });
  };

  const handleOrder = () => {
    const sel = address?.find((a) => a?.delivery_address_id === delAd) || (address && address[address.length - 1]);
    if (!sel) {
      toast.info("Please add a delivery address to proceed with your order", {
        position: "top-right",
        autoClose: 3000,
      });
      setIsAddressModalOpen(true);
      if (!address || address.length === 0) {
        setNewDelivery(true);
        setOpen(false);
      }
      return;
    }

    if (delAd === null && sel) {
      setDelAd(sel.delivery_address_id);
    }
    let payload = {};
    payload.delivery_id = sel.delivery_address_id;
    payload.cart_id = data.map((item) => item.cart_id);

    setLoading(true);
    fetch(backend + "createorder", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authenticated?.access_token}`,
      },
      body: JSON.stringify(payload),
    })
      .then((response) => {
        if (!response.ok) {
          console.error(
            "Failed to register:",
            response.status,
            response.statusText
          );
          if (response.status === 409) {
            toast.error("Something Went Wrong", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else {
            toast.error("Something Went Wrong", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }

          setLoading(false);
          return;
        }

        response.json().then((data) => {
          handlePayment(data.order_no, data.grandTotalPrice, data.user_details);
          // Additional success handling code here
          // toast.success("Order Generated", {
          //   position: "top-right",
          //   autoClose: 3000,
          //   hideProgressBar: false,
          //   closeOnClick: true,
          //   pauseOnHover: true,
          //   draggable: true,
          //   progress: undefined,
          // });
        });
        // navigate("/admin-users");
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Something Went Wrong", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      });
  };

  const handleOrderAddress = (id) => {
    let payload = {};
    payload.delivery_id = id;
    payload.cart_id = data.map((item) => item.cart_id);

    setLoading(true);
    fetch(backend + "createorder", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authenticated?.access_token}`,
      },
      body: JSON.stringify(payload),
    })
      .then((response) => {
        if (!response.ok) {
          console.error(
            "Failed to register:",
            response.status,
            response.statusText
          );
          if (response.status === 409) {
            toast.error("Something Went Wrong", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else {
            toast.error("Something Went Wrong", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }

          setLoading(false);
          return;
        }

        response.json().then((data) => {
          handlePayment(data.order_no, data.grandTotalPrice, data.user_details);
          // Additional success handling code here
          // toast.success("Order Generated", {
          //   position: "top-right",
          //   autoClose: 3000,
          //   hideProgressBar: false,
          //   closeOnClick: true,
          //   pauseOnHover: true,
          //   draggable: true,
          //   progress: undefined,
          // });
        });
        // navigate("/admin-users");
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Something Went Wrong", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      });
  };

  const handleSuccessOrder = (order_id, pay_id) => {
    setLoading(true);
    let payload = {};
    payload.razorpay_payment_id = pay_id;
    payload.order_no = order_id;
    payload.cart_id = data.map((item) => item.cart_id);

    fetch(backend + "successfullpayment", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${authenticated?.access_token}`,
      },
      body: JSON.stringify(payload),
    })
      .then((response) => {
        if (!response.ok) {
          setLoading(false);
          console.error(
            "Failed to register:",
            response.status,
            response.statusText
          );
          if (response.status === 409) {
            toast.error("Something Went Wrong", {
              position: "top-right",
              autoClose: 3000,
            });
          } else {
            toast.error("Something Went Wrong", {
              position: "top-right",
              autoClose: 3000,
            });
          }

          return;
        }

        response.json().then(() => {
          setLoading(false);
          toast.success("Order Placed Successfully", {
            position: "top-right",
            autoClose: 3000,
          });
        });
      })
      .catch((error) => {
        setLoading(false);
        toast.error("Something Went Wrong", {
          position: "top-right",
          autoClose: 3000,
        });
      });
  };

  const handleProductRoute = (productId) => {
    navigate(`/product/${productId}`);
  };

  const handleCopyTracking = (trackingId) => {
    navigator.clipboard
      .writeText(trackingId)
      .then(() => {
        console.log("Tracking ID copied to clipboard");
      })
      .catch((err) => {
        console.error("Failed to copy tracking ID: ", err);
      });
    setCopy(true);
  };

  const getStatusLabel = (status) => {
    switch (status) {
      case 1:
        return "Processing";
      case 2:
        return "Dispatched";
      case 3:
        return "Delivered";
      case 4:
        return "Cancelled";
      default:
        return "Pending";
    }
  };

  const getStatusVariant = (status) => {
    switch (status) {
      case 1:
        return "warning";
      case 2:
        return "info";
      case 3:
        return "success";
      case 4:
        return "danger";
      default:
        return "neutral";
    }
  };




  const ordersCount = data.length;
  const deliveredCount = data.filter((item) => item?.status === 3).length;
  const totalAmount = calculateTotalMRP();

  return (
    <main className="main" id="main-section">
      <PageWrapper>
        <HeroSection>
          <BreadcrumbTrail>
            <Link to="/">Home</Link>
            <span>/</span>
            <span>My Orders</span>
          </BreadcrumbTrail>
          <HeroContent>
            <HeroBadge>Order Overview</HeroBadge>
            <HeroTitle>Your KeralaSpecial orders</HeroTitle>
            <HeroSubtitle>
              Track your purchases, follow deliveries, and manage your experience in one elegant view.
            </HeroSubtitle>
            <HeroStats>
              <StatCard>
                <StatValue>{ordersCount}</StatValue>
                <StatLabel>Total orders</StatLabel>
              </StatCard>
              <StatCard>
                <StatValue>{deliveredCount}</StatValue>
                <StatLabel>Delivered</StatLabel>
              </StatCard>
              {/* <StatCard>
                <StatValue>₹ {totalAmount}</StatValue>
                <StatLabel>Total spend</StatLabel>
              </StatCard> */}
            </HeroStats>
          </HeroContent>
        </HeroSection>

        <OrdersSection>
          <SectionHeader>
            <SectionTitle>Order history</SectionTitle>
            <SectionSubtitle>
              Explore order status, delivery details, and invoices. Cancel or track your packages with ease.
            </SectionSubtitle>
          </SectionHeader>

          {loading ? (
            <LoaderWrapper>
              <LoaderMain />
            </LoaderWrapper>
          ) : ordersCount > 0 ? (
            <OrderGrid>
              {data.map((item) => {
                const statusLabel = getStatusLabel(item?.status);
                const statusVariant = getStatusVariant(item?.status);
                const manufacturer = item?.manufacturer_name ?? "KeralaSpecial";
                const address = [
                  item?.house_name,
                  item?.street_name,
                  item?.city,
                  item?.pincode,
                ]
                  .filter(Boolean)
                  .join(", ");
                const hasTracking = Boolean(item?.tracking_id);
                const hasBill = Boolean(item?.bill_file);

                return (
                  <OrderCard key={`${item?.order_id}-${item?.product_slug}`}>
                    <CardHeader>
                      <ProductPreview onClick={() => handleProductRoute(item.product_slug)}>
                        <ProductImage src={producturl + item?.thumbnail} alt={item?.product_name} />
                      </ProductPreview>
                      <HeaderContent>
                        <ProductCategory onClick={() => handleProductRoute(item.product_slug)}>
                          {item?.category_name}
                        </ProductCategory>
                        <ProductName href={`/product/${item.product_slug}`}>
                          {item?.product_name}
                        </ProductName>
                        <ProductMeta>
                          Sold by <strong onClick={() => handleProductRoute(item.product_slug)}>{manufacturer}</strong>
                        </ProductMeta>
                      </HeaderContent>
                      <StatusRow>
                        <StatusBadge variant={statusVariant}>{statusLabel}</StatusBadge>
                        {hasTracking && <TrackingId>Tracking ID: {item.tracking_id}</TrackingId>}
                      </StatusRow>
                    </CardHeader>

                    <CardBody>
                      <AddressBlock>
                        <AddressLabel>Delivery address</AddressLabel>
                        <AddressText>{address}</AddressText>
                      </AddressBlock>

                      <OrderSummary>
                        <AmountBlock>
                          <SummaryLabel>Total amount</SummaryLabel>
                          <SummaryValue>₹ {item?.original_amount}</SummaryValue>
                        </AmountBlock>
                        <AmountBlock>
                          <SummaryLabel>Quantity</SummaryLabel>
                          <SummaryValue>{item?.quantity}</SummaryValue>
                        </AmountBlock>
                      </OrderSummary>

                      <ActionArea>
                        <ActionButtons>
                          {item?.return === 0 && item?.status !== 4 && (
                            <CancelButton
                              type="button"
                              isHovered={isHovered}
                              onMouseEnter={() => setIsHovered(true)}
                              onMouseLeave={() => setIsHovered(false)}
                              onClick={() => handleCancelClick(item?.order_id)}
                            >
                              Cancel order
                            </CancelButton>
                          )}

                          {hasTracking && (
                            <TrackingActions>
                              <CopyButton type="button" onClick={() => handleCopyTracking(item.tracking_id)}>
                                {copy ? "Copied" : "Copy tracking ID"}
                                <CopyIcon
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 32 32"
                                >
                                  <path d="M9.17 6H7.5A1.5 1.5 0 0 0 6 7.5v19A1.5 1.5 0 0 0 7.5 28H12a1 1 0 1 1 0 2H7.5A3.5 3.5 0 0 1 4 26.5v-19A3.5 3.5 0 0 1 7.5 4h1.67A3 3 0 0 1 12 2h6c1.306 0 2.418.835 2.83 2h1.67A3.5 3.5 0 0 1 26 7.5a1 1 0 1 1-2 0A1.5 1.5 0 0 0 22.5 6h-1.67A3 3 0 0 1 18 8h-6a3 3 0 0 1-2.83-2M11 5a1 1 0 0 0 1 1h6a1 1 0 1 0 0-2h-6a1 1 0 0 0-1 1m3 8.5a3.5 3.5 0 0 1 3.5-3.5h8a3.5 3.5 0 0 1 3.5 3.5v13a3.5 3.5 0 0 1-3.5 3.5h-8a3.5 3.5 0 0 1-3.5-3.5z" fill="currentColor" />
                                </CopyIcon>
                              </CopyButton>
                              <TrackButton
                                as="a"
                                href={item?.url}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                Track package
                              </TrackButton>
                            </TrackingActions>
                          )}

                          {hasBill && (
                            <DownloadButton
                              as="a"
                              href={billurl + item?.bill_file}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Download bill
                            </DownloadButton>
                          )}
                        </ActionButtons>
                      </ActionArea>
                    </CardBody>
                  </OrderCard>
                );
              })}
            </OrderGrid>
          ) : (
            <EmptyState>
              <EmptyTitle>No orders yet</EmptyTitle>
              <EmptySubtitle>
                You haven't done any orders yet! Discover handcrafted delights and place your first order today.
              </EmptySubtitle>
            </EmptyState>
          )}
        </OrdersSection>

        <Modal show={isAddressModalOpen} onHide={() => setIsAddressModalOpen(false)} size="2xl" centered>
          <Modal.Header closeButton>
            <Modal.Title>Delivery Address</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="mb-3 d-flex gap-2">
              {address[0]?.city ? (
                <ActionButton
                  onClick={() => {
                    setNewDelivery(!newDelivery);
                    setOpen(false);
                  }}
                  aria-controls="example-new-text"
                  aria-expanded={newDelivery}
                >
                  <HiOutlinePlus /> Add New
                </ActionButton>
              ) : (
                <ActionButton
                  onClick={() => {
                    setNewDelivery(false);
                    setOpen(!open);
                  }}
                  aria-controls="example-collapse-text"
                  aria-expanded={open}
                >
                  <HiOutlinePlus /> Add New
                </ActionButton>
              )}
            </div>

            <AddressGrid>
              {address?.map((item, i) => {
                const selected = delAd === item?.delivery_address_id;
                return (
                  <AddressCard
                    key={i}
                    className={selected ? "selected" : ""}
                    onClick={() => setDelAd(item?.delivery_address_id)}
                  >
                    <GridItem className="card-main">
                      <AddressName>
                        {item?.first_name} {item?.last_name}
                      </AddressName>
                      {item?.house_name && item?.city && item?.pincode ? (
                        <AddressMeta>
                          {item?.house_name}, {item?.street_name},{" "}
                          {item?.city}, {item?.state},{" "}
                          {item?.countryname} - {item?.pincode}
                          <br />
                          PH NO: {item?.contact}
                        </AddressMeta>
                      ) : (
                        <AddressMeta>No more details</AddressMeta>
                      )}
                    </GridItem>
                    <DeleteButton
                      type="button"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDeleteAddress(item?.delivery_address_id);
                      }}
                    >
                      Delete
                    </DeleteButton>
                  </AddressCard>
                );
              })}
            </AddressGrid>

            {delAd && (
              <SelectedPreview>
                {(() => {
                  const sel = address?.find(
                    (a) => a?.delivery_address_id === delAd
                  );
                  return sel ? (
                    <div>
                      <strong>Selected:</strong> {sel?.first_name}{" "}
                      {sel?.last_name} — {sel?.house_name}, {sel?.street_name},{" "}
                      {sel?.city}, {sel?.state}, {sel?.countryname} -{" "}
                      {sel?.pincode}. PH: {sel?.contact}
                    </div>
                  ) : null;
                })()}
              </SelectedPreview>
            )}

            {open && (
              <div className="pt-2" id="example-collapse-text">
                <ModalForm>
                  <div className="form__content">
                    <div className="row">
                      <div className="col-lg-4 col-md-4 col-6">
                        <div className="">
                          <label htmlFor="name">First Name</label>{" "}
                          <sup style={{ color: "red", fontSize: "13px" }}>*</sup>
                          <input
                            className=""
                            name="product_name"
                            id="txt-name"
                            type="text"
                            value={formData?.first_name || ""}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                first_name: e.target.value,
                              })
                            }
                            placeholder="First Name"
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-4 col-6">
                        <div className="">
                          <label htmlFor="name">Last Name</label>{" "}
                          <sup style={{ color: "red", fontSize: "13px" }}>*</sup>
                          <input
                            className=""
                            name="last_name"
                            id="txt-name"
                            type="text"
                            value={formData?.last_name || ""}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                last_name: e.target.value,
                              })
                            }
                            placeholder="Last Name"
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-4 col-12">
                        <div className="">
                          <label htmlFor="name">House Name / House Number / Apartment</label>{" "}
                          <sup style={{ color: "red", fontSize: "13px" }}>*</sup>
                          <input
                            className=""
                            name="house_name"
                            id="txt-name"
                            type="text"
                            value={formData?.house_name || ""}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                house_name: e.target.value,
                              })
                            }
                            placeholder="House Name / House Number / Apartment"
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-4 col-6">
                        <div className="">
                          <label htmlFor="name">Street Name</label>
                          <input
                            className=""
                            name="street_name"
                            id="txt-name"
                            type="text"
                            value={formData?.street_name || ""}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                street_name: e.target.value,
                              })
                            }
                            placeholder="Street Name"
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-4 col-6">
                        <div className="">
                          <label htmlFor="city">City</label>
                          <sup style={{ color: "red", fontSize: "13px" }}>*</sup>
                          <input
                            type="text"
                            name="city"
                            required
                            value={formData?.city || ""}
                            onChange={(e) =>
                              setFormData({ ...formData, city: e.target.value })
                            }
                            placeholder="City"
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-4 col-6">
                        <div className="">
                          <label htmlFor="state">State</label>
                          <sup style={{ color: "red", fontSize: "13px" }}>*</sup>
                          <input
                            type="text"
                            name="state"
                            required
                            value={formData?.state || ""}
                            onChange={(e) =>
                              setFormData({ ...formData, state: e.target.value })
                            }
                            placeholder="State"
                          />
                        </div>
                      </div>

                      <div className="col-lg-4 col-md-4 col-6">
                        <div className="">
                          <label htmlFor="pincode">Pincode</label>
                          <sup style={{ color: "red", fontSize: "13px" }}>*</sup>
                          <input
                            type="text"
                            name="pincode"
                            required
                            value={formData?.pincode || ""}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                pincode: e.target.value,
                              })
                            }
                            placeholder="Pincode"
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-4 col-6">
                        <div className="">
                          <label htmlFor="contact">Contact Number</label>
                          <sup style={{ color: "red", fontSize: "13px" }}>*</sup>
                          <input
                            type="text"
                            name="contact"
                            required
                            value={formData?.contact || ""}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                contact: e.target.value,
                              })
                            }
                            placeholder="Contact Number"
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-4 col-6">
                        <div className="form-group">
                          <label htmlFor="country">Country</label>
                          <sup style={{ color: "red", fontSize: "13px" }}>*</sup>
                          <select
                            className="form-control"
                            name="country"
                            value={formData?.country || ""}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                country: e.target.value,
                              })
                            }
                          >
                            <option value="">Select Country</option>
                            {count.map((country) => (
                              <option
                                key={country.id}
                                value={country.country_id}
                              >
                                {country.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="custome-checkbox">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="agree_terms_and_policy"
                            id="agree-terms-and-policy"
                            checked={formData?.is_primary === 0}
                            onChange={(e) =>
                              setFormData({
                                ...formData,
                                is_primary: e.target.checked ? 0 : 1,
                              })
                            }
                          />
                          <label
                            className="form-check-label"
                            htmlFor="agree-terms-and-policy"
                          >
                            <span>
                              <a>Set this as my primary address.</a>
                            </span>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div>
                      <ActionButton type="button" onClick={() => handleSubmit()}>
                        Submit
                      </ActionButton>
                    </div>
                  </div>
                </ModalForm>
              </div>
            )}

            {newDelivery && (
              <div className="pt-2" id="example-new-text">
                <ModalForm>
                  <div className="form__content">
                    <div className="row">
                      <div className="col-lg-4 col-md-4 col-6">
                        <div className="">
                          <label htmlFor="name">First Name</label>{" "}
                          <sup style={{ color: "red", fontSize: "13px" }}>*</sup>
                          <input
                            className=""
                            name="product_name"
                            id="txt-name"
                            type="text"
                            value={newAdd?.first_name || ""}
                            onChange={(e) =>
                              setNewAdd({
                                ...newAdd,
                                first_name: e.target.value,
                              })
                            }
                            placeholder="First Name"
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-4 col-6">
                        <div className="">
                          <label htmlFor="name">Last Name</label>{" "}
                          <sup style={{ color: "red", fontSize: "13px" }}>*</sup>
                          <input
                            className=""
                            name="last_name"
                            id="txt-name"
                            type="text"
                            value={newAdd?.last_name || ""}
                            onChange={(e) =>
                              setNewAdd({
                                ...newAdd,
                                last_name: e.target.value,
                              })
                            }
                            placeholder="Last Name"
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-4 col-12">
                        <div className="">
                          <label htmlFor="name">House Name / House Number / Apartment</label>{" "}
                          <sup style={{ color: "red", fontSize: "13px" }}>*</sup>
                          <input
                            className=""
                            name="house_name"
                            id="txt-name"
                            type="text"
                            value={newAdd.house_name || ""}
                            onChange={(e) =>
                              setNewAdd({
                                ...newAdd,
                                house_name: e.target.value,
                              })
                            }
                            placeholder="House Name / House Number / Apartment"
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-4 col-6">
                        <div className="">
                          <label htmlFor="name">Street Name</label>
                          <input
                            className=""
                            name="street_name"
                            id="txt-name"
                            type="text"
                            value={newAdd?.street_name || ""}
                            onChange={(e) =>
                              setNewAdd({
                                ...newAdd,
                                street_name: e.target.value,
                              })
                            }
                            placeholder="Street Name"
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-4 col-6">
                        <div className="">
                          <label htmlFor="city">City</label>
                          <sup style={{ color: "red", fontSize: "13px" }}>*</sup>
                          <input
                            type="text"
                            name="city"
                            required
                            value={newAdd?.city || ""}
                            onChange={(e) =>
                              setNewAdd({ ...newAdd, city: e.target.value })
                            }
                            placeholder="City"
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-4 col-6">
                        <div className="">
                          <label htmlFor="state">State</label>
                          <sup style={{ color: "red", fontSize: "13px" }}>*</sup>
                          <input
                            type="text"
                            name="state"
                            required
                            value={newAdd?.state || ""}
                            onChange={(e) =>
                              setNewAdd({ ...newAdd, state: e.target.value })
                            }
                            placeholder="State"
                          />
                        </div>
                      </div>

                      <div className="col-lg-4 col-md-4 col-6">
                        <div className="">
                          <label htmlFor="pincode">Pincode</label>
                          <sup style={{ color: "red", fontSize: "13px" }}>*</sup>
                          <input
                            type="text"
                            name="pincode"
                            required
                            value={newAdd?.pincode || ""}
                            onChange={(e) =>
                              setNewAdd({
                                ...newAdd,
                                pincode: e.target.value,
                              })
                            }
                            placeholder="Pincode"
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-4 col-6">
                        <div className="">
                          <label htmlFor="contact">Contact Number</label>
                          <sup style={{ color: "red", fontSize: "13px" }}>*</sup>
                          <input
                            type="text"
                            name="contact"
                            required
                            value={newAdd?.contact || ""}
                            onChange={(e) =>
                              setNewAdd({
                                ...newAdd,
                                contact: e.target.value,
                              })
                            }
                            placeholder="Contact Number"
                          />
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-4 col-6">
                        <div className="form-group">
                          <label htmlFor="country">Country</label>
                          <sup style={{ color: "red", fontSize: "13px" }}>*</sup>
                          <select
                            className="form-control"
                            name="country"
                            value={newAdd?.country || ""}
                            onChange={(e) =>
                              setNewAdd({
                                ...newAdd,
                                country: e.target.value,
                              })
                            }
                          >
                            <option value="">Select Country</option>
                            {count.map((country) => (
                              <option
                                key={country.id}
                                value={country.country_id}
                              >
                                {country.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="custome-checkbox">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            name="agree_terms_and_policy"
                            id="agree-terms-and-policy"
                            checked={newAdd?.is_primary === 0}
                            onChange={(e) =>
                              setNewAdd({
                                ...newAdd,
                                is_primary: e.target.checked ? 0 : 1,
                              })
                            }
                          />
                          <label
                            className="form-check-label"
                            htmlFor="agree-terms-and-policy"
                          >
                            <span>
                              <a>Set this as my primary address.</a>
                            </span>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div>
                      <ActionButton type="button" onClick={() => handleSubmitNewAddress()}>
                        Submit
                      </ActionButton>
                    </div>
                  </div>
                </ModalForm>
              </div>
            )}
          </Modal.Body>
          <Modal.Footer>
            <SecondaryActionButton onClick={() => setIsAddressModalOpen(false)}>Close</SecondaryActionButton>
          </Modal.Footer>
        </Modal>

        <ToastContainer />
        <ScrollToTop />
      </PageWrapper>
    </main>
  );
}

export default MyOrdersUser;

const PageWrapper = styled.div`
  max-width: 90vw;
  margin: 0 auto;
  padding: 0 24px 96px;
  display: flex;
  flex-direction: column;
  gap: 72px;
`;

const HeroSection = styled.section`
  margin-top: 56px;
  background: linear-gradient(135deg, #fff3e2 0%, #ffffff 65%);
  border-radius: 32px;
  padding: 48px 56px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  box-shadow: 0 40px 80px rgba(15, 23, 42, 0.08);

  @media screen and (max-width: 768px) {
    padding: 40px 28px;
  }
`;

const BreadcrumbTrail = styled.nav`
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 14px;
  color: #6b7280;

  a {
    color: inherit;
    font-weight: 500;
  }

  span:last-child {
    color: #111827;
    font-weight: 600;
  }
`;

const HeroContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const HeroBadge = styled.span`
  display: inline-flex;
  align-items: center;
  background: rgba(98, 188, 1, 0.15);
  color: #255121;
  padding: 8px 16px;
  border-radius: 999px;
  font-size: 12px;
  letter-spacing: 1.6px;
  text-transform: uppercase;
  font-weight: 600;
`;

const HeroTitle = styled.h1`
  margin: 0;
  font-size: 44px;
  line-height: 1.1;
  color: #0f172a;

  @media screen and (max-width: 768px) {
    font-size: 34px;
  }
`;

const HeroSubtitle = styled.p`
  margin: 0;
  color: #374151;
  line-height: 1.7;
  font-size: 16px;
`;

const HeroStats = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 18px;
  margin-top: 20px;
`;

const StatCard = styled.div`
  min-width: 160px;
  padding: 18px 20px;
  border-radius: 18px;
  background: #ffffff;
  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.08);
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const StatValue = styled.span`
  font-size: 26px;
  font-weight: 700;
  color: #0f172a;
`;

const StatLabel = styled.span`
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 1.4px;
  color: #6b7280;
`;

const OrdersSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

const SectionHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const SectionTitle = styled.h2`
  margin: 0;
  font-size: 28px;
  font-weight: 600;
  color: #0f172a;
  text-transform: uppercase;
  letter-spacing: 1.2px;
`;

const SectionSubtitle = styled.p`
  margin: 0;
  color: #4b5563;
  font-size: 15px;
`;

const OrderGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const OrderCard = styled.article`
  background: #ffffff;
  border-radius: 28px;
  padding: 28px;
  box-shadow: 0 24px 60px rgba(15, 23, 42, 0.08);
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media screen and (max-width: 640px) {
    padding: 24px;
  }
`;

const CardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
`;

const ProductPreview = styled.button`
  padding: 0;
  border: none;
  background: transparent;
  border-radius: 18px;
  overflow: hidden;
  width: 108px;
  height: 108px;
  cursor: pointer;
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.12);
  transition: transform 0.25s ease;

  &:hover {
    transform: translateY(-4px);
  }
`;

const ProductImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

const HeaderContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 200px;
`;

const ProductCategory = styled.span`
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 1.4px;
  color: #62bc01;
  font-weight: 600;
  cursor: pointer;
`;

const ProductName = styled.a`
  font-size: 22px;
  font-weight: 600;
  color: #0f172a;
  text-decoration: none;
  display: inline-block;

  &:hover {
    color: #62bc01;
  }
`;

const ProductMeta = styled.span`
  font-size: 14px;
  color: #475569;

  strong {
    font-weight: 600;
    color: #0f172a;
    cursor: pointer;
  }
`;

const StatusRow = styled.div`
  margin-left: auto;
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: flex-end;

  @media screen and (max-width: 768px) {
    width: 100%;
    align-items: flex-start;
  }
`;

const StatusBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 8px 16px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1.2px;
  color: ${({ variant }) =>
    variant === "success"
      ? "#0f5132"
      : variant === "danger"
        ? "#b91c1c"
        : variant === "warning"
          ? "#92400e"
          : variant === "info"
            ? "#1d4ed8"
            : "#334155"};
  background: ${({ variant }) =>
    variant === "success"
      ? "rgba(16, 185, 129, 0.16)"
      : variant === "danger"
        ? "rgba(248, 113, 113, 0.16)"
        : variant === "warning"
          ? "rgba(251, 191, 36, 0.16)"
          : variant === "info"
            ? "rgba(96, 165, 250, 0.16)"
            : "rgba(148, 163, 184, 0.2)"};
`;

const TrackingId = styled.span`
  font-size: 13px;
  color: #4b5563;
`;

const CardBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const AddressBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const AddressLabel = styled.span`
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 1.4px;
  color: #6b7280;
`;

const AddressText = styled.p`
  margin: 0;
  color: #1f2937;
  font-size: 15px;
  line-height: 1.6;
`;

const OrderSummary = styled.div`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
`;

const AmountBlock = styled.div`
  min-width: 140px;
  padding: 16px 18px;
  border-radius: 16px;
  background: rgba(98, 188, 1, 0.08);
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const SummaryLabel = styled.span`
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 1.4px;
  color: #467413;
`;

const SummaryValue = styled.span`
  font-size: 18px;
  font-weight: 700;
  color: #0e3910;
`;

const ActionArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
`;

const ActionButtons = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
`;

const CancelButton = styled.button`
  padding: 12px 20px;
  border-radius: 999px;
  border: 1px solid ${({ isHovered }) => (isHovered ? "#fff" : "#b91c1c")};
  background: ${({ isHovered }) => (isHovered ? "#b91c1c" : "#ffffff")};
  color: ${({ isHovered }) => (isHovered ? "#fff" : "#b91c1c")};
  font-weight: 600;
  cursor: pointer;
  transition: all 0.25s ease;
`;

const TrackingActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
`;

const CopyButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 12px 20px;
  border-radius: 999px;
  border: none;
  background: #111827;
  color: #f9fafb;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 24px rgba(30, 41, 59, 0.2);
  }
`;

const CopyIcon = styled.svg`
  width: 18px;
  height: 18px;
`;

const TrackButton = styled.button`
  padding: 12px 22px;
  border-radius: 999px;
  border: none;
  background: linear-gradient(135deg, #62bc01 0%, #3a7d16 100%);
  color: #ffffff;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 16px 24px rgba(98, 188, 1, 0.35);
  }
`;

const DownloadButton = styled.button`
  padding: 12px 22px;
  border-radius: 999px;
  border: none;
  background: rgba(17, 24, 39, 0.08);
  color: #111827;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 16px 24px rgba(15, 23, 42, 0.15);
  }
`;

const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 80px 0;
`;

const EmptyState = styled.div`
  padding: 80px 20px;
  border-radius: 32px;
  background: rgba(15, 23, 42, 0.04);
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const EmptyTitle = styled.h3`
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  color: #0f172a;
`;

const EmptySubtitle = styled.p`
  margin: 0;
  font-size: 15px;
  color: #475569;
`;
const ActionsRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
`;

const SecondaryActionButton = styled.button`
  background: #f8fafc;
  color: #475569;
  border: 1px solid #e2e8f0;
  padding: 8px 18px;
  border-radius: 10px;
  font-weight: 600;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;

  &:hover {
    background: #f1f5f9;
    color: #1e293b;
    border-color: #cbd5e1;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  }

  &:active {
    transform: scale(0.96);
  }
`;

const ActionButton = styled.button`
  background: #3bb77e;
  color: #fff;
  border: none;
  padding: 8px 18px;
  border-radius: 10px;
  font-weight: 600;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 14px rgba(59, 183, 126, 0.25);
  cursor: pointer;

  &:hover {
    background: #2faa70;
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(59, 183, 126, 0.35);
  }

  &:active {
    transform: scale(0.96);
  }

  &:disabled {
    background: #ccc;
    cursor: not-allowed;
    box-shadow: none;
    transform: none;
  }

  svg {
    font-size: 18px;
  }
`;

const DeleteButton = styled.button`
  border: none;
  background: #fff5f5;
  color: #e11d48;
  padding: 6px 12px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 13px;
  height: fit-content;
  transition: all 0.2s ease;
  border: 1px solid #fee2e2;
  cursor: pointer;

  &:hover {
    background: #e11d48;
    color: #fff;
    border-color: #e11d48;
    transform: scale(0.95);
  }

  &:active {
    transform: scale(0.9);
  }
`;

const AddressGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 16px;
  margin-top: 20px;
`;

const AddressCard = styled.div`
  border: 1px solid #e5e7eb;
  padding: 16px;
  border-radius: 12px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  transition: all 0.2s ease;

  &:hover { border-color: #3bb77e; background: #f0fdf4; }
  &.selected { border-color: #3bb77e; background: #f0fdf4; border-width: 2px; }
`;

const AddressName = styled.h6`
  font-weight: 700;
  margin-bottom: 4px;
  color: #111827;
`;

const AddressMeta = styled.p`
  font-size: 13px;
  color: #4b5563;
  line-height: 1.5;
`;

const SelectedPreview = styled.div`
  margin-top: 20px;
  padding: 12px 16px;
  background: #f0fdf4;
  border-radius: 10px;
  border-left: 4px solid #3bb77e;
  font-size: 14px;
`;

const ModalForm = styled.div`
  padding: 16px;
  background: #f9fafb;
  border-radius: 12px;
  margin-top: 16px;

  input, select {
    width: 100%;
    padding: 10px;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    margin-top: 6px;
    margin-bottom: 12px;
    font-size: 14px;
  }
  label { font-weight: 600; font-size: 14px; color: #374151; }
`;

const GridItem = styled.div`
  flex: 1;
`;
